import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import KPIDashboard from './pages/KPIDashboard';
import ProjectMargins from './pages/ProjectMargins';
import Settings from './pages/Settings';
import Sandbox from './pages/Sandbox';
import CAC from './pages/CAC';
import Reconciliation from './pages/Reconciliation';
import Revenue from './pages/Revenue';
import Utilisation from './pages/Utilisation';
import Schedule from './pages/Schedule';
import SignIn from './pages/SignIn';
import { SessionProvider, useSession } from './auth/session';

function Shell() {
  const { loading, user } = useSession();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <p className="text-sm text-slate-500">Loading…</p>
      </div>
    );
  }

  if (!user) return <SignIn />;

  return (
    <div className="flex min-h-screen bg-slate-950">
      <Nav />
      <main className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto px-10 py-10">
          <Routes>
            <Route path="/"         element={<KPIDashboard />} />
            <Route path="/projects" element={<ProjectMargins />} />
            <Route path="/recon"    element={<Reconciliation />} />
            <Route path="/revenue"  element={<Revenue />} />
            <Route path="/utilisation" element={<Utilisation />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/cac"      element={<CAC />} />
            <Route path="/sandbox"  element={<Sandbox />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </SessionProvider>
  );
}
